(function () {
  var pushedForms = {};

  var pageForms = {
    'tm7-book-a-demo': { event: 'tm_demo_request', form_name: 'tm_demo_request', form_type: 'Standard' },
    'book-a-demo': { event: 'tm_demo_request', form_name: 'tm_demo_request', form_type: 'Standard' },
    'book-demo-tm': { event: 'tm_demo_request', form_name: 'tm_demo_request', form_type: 'Standard' },
    'contact-us': { event: 'tm_contact_request', form_name: 'tm_contact_request', form_type: 'Standard' },
    'contact-v2': { event: 'tm_contact_request', form_name: 'tm_contact_request', form_type: 'Standard' },
    'join-us': { event: 'tm_career_request', form_name: 'tm_career_request', form_type: 'Standard' },
    'become-a-member': { event: 'tm_career_request', form_name: 'tm_career_request', form_type: 'Standard' },
    ebulten: { event: 'newsletter_request', form_name: 'newsletter_request', form_type: 'Standard', newsletter: true },
    newsletter: { event: 'newsletter_request', form_name: 'newsletter_request', form_type: 'Standard', newsletter: true },
    'tadim-tanitim-atolyeleri': { event: 'tm_workshop_request', form_name: 'tm_workshop_request', form_type: 'Standard', workshop: true }
  };

  var demoIntroForm = { event: 'tm_demo_request', form_name: 'tm_demo_intro_request', form_type: 'Standard' };
  var demoFormIds = {
    'rrIDD-aaoQflt67vaJmPGg': true,
    'rrIDD-aaoQfit67vaJmPGg': true,
    'MKlWabHeh41gt6_02OAmzw': true
  };

  var formsById = {
    'IgLq0yGXkdaFvq1LzFukYA': pageForms['contact-us'],
    'Igl_q0yGXkdaFvq1LzFukYA': pageForms['contact-us'],
    'oMkHZoPniwWS18LUWwQFbw': pageForms.ebulten,
    'oMkHZoPniwWS1BLUWwQFBw': pageForms.ebulten,
    'X-TC6x82oc0Q_R5KxT-fFw': pageForms['tadim-tanitim-atolyeleri'],
    'X-TC6xB2oc0Q_R5KxT-fFiw': pageForms['tadim-tanitim-atolyeleri'],
    'rrIDD-aaoQflt67vaJmPGg': pageForms['tm7-book-a-demo'],
    'rrIDD-aaoQfit67vaJmPGg': pageForms['tm7-book-a-demo'],
    'MKlWabHeh41gt6_02OAmzw': pageForms['tm7-book-a-demo'],
    'VLvsBioHJ5Ce-TKVpwI-0Q': pageForms['join-us'],
    'VLvsBioHJ5Ce-TKVpwl-0Q': pageForms['join-us']
  };

  var exceptionAt = {};

  function dataLayer() {
    window.dataLayer = window.dataLayer || [];
    return window.dataLayer;
  }

  function pageContext() {
    var layer = window.dataLayer || [];
    for (var i = 0; i < layer.length; i++) {
      if (layer[i] && layer[i].page_type) return layer[i];
    }
    return {};
  }

  function pageHandle() {
    var match = (document.body.className || '').match(/page-handle-([^\s]+)/);
    return match ? match[1] : '';
  }

  function allowsPageMap() {
    var country = pageContext().country;
    return !country || country === 'tr';
  }

  function hulkFormConfig(data) {
    var payload = data && data.payload;
    var formId = data && (data.formId || data.form_id || (payload && (payload.form_id || payload.formId)));
    var mapped = window.vwAnalyticsHulkForms || {};
    if (formId && mapped[formId]) return mapped[formId];
    if (formId && demoFormIds[formId] && pageHandle() === 'tanisma-toplantisi') return demoIntroForm;
    if (formId && formsById[formId]) return formsById[formId];
    if (!allowsPageMap()) return null;
    return pageForms[pageHandle()] || null;
  }

  function present(value) {
    if (value === undefined || value === null || value === '') return undefined;
    var text = String(value).trim();
    if (!text) return undefined;
    if (/[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}/i.test(text)) return undefined;
    if (text.replace(/\D/g, '').length >= 10) return undefined;
    return text;
  }

  function deviceOwner(payload) {
    var found;
    function walk(node) {
      if (found || node == null) return;
      if (typeof node === 'string') {
        var value = node.trim().toLowerCase();
        if (value.length > 12) return;
        if (value === 'evet' || value === 'yes' || value === 'tm7') found = 'tm7';
        else if (value === 'hayır' || value === 'hayir' || value === 'no' || value === 'none') found = 'none';
        return;
      }
      if (typeof node === 'object') {
        Object.keys(node).forEach(function (childKey) {
          walk(node[childKey]);
        });
      }
    }
    walk(payload);
    return found;
  }

  var deviceOwnerByForm = {};

  function pushFormSuccess(config, payload, formId) {
    if (config.newsletter && payload && payload.newsletter_checked === false) return;
    var key = config.form_name;
    if (pushedForms[key] === 'success') return;
    pushedForms[key] = 'success';

    var owner = config.workshop ? (deviceOwner(payload) || deviceOwnerByForm[formId || '']) : undefined;
    dataLayer().push({
      event: config.event,
      form_name: config.form_name,
      form_type: config.form_type || 'Standard',
      device_owner: config.newsletter ? undefined : owner
    });
  }

  function pushException(config, description, errorMessage, errorFields) {
    dataLayer().push({
      event: 'exception',
      description: description,
      error_message: present(errorMessage),
      error_fields: present(errorFields),
      form_name: config ? config.form_name : undefined,
      form_type: config ? (config.form_type || 'Standard') : undefined
    });
  }

  function formConfigFromElement(form) {
    var formName = form.getAttribute('data-analytics-form-name');
    if (!formName) return null;
    return {
      event: form.getAttribute('data-analytics-form-event') || 'form_submission',
      form_name: formName,
      form_type: form.getAttribute('data-analytics-form-type') || 'Standard',
      workshop: form.getAttribute('data-analytics-device-owner') === 'true',
      newsletter: form.getAttribute('data-analytics-newsletter') === 'true'
    };
  }

  function flushPendingAdvisorAssignment() {
    var pending;
    try { pending = sessionStorage.getItem('analytics_advisor_assignment_pending'); } catch (e) { return; }
    if (!pending) return;
    try { sessionStorage.removeItem('analytics_advisor_assignment_pending'); } catch (e) {}
    dataLayer().push({
      event: 'advisor_assignment',
      advisor_id: pending
    });
  }

  document.addEventListener('advisor:selected', function (event) {
    var id = event.detail && event.detail.id;
    if (!id || id === '-') return;
    var stored = String(id);
    try {
      if (sessionStorage.getItem('analytics_advisor_assignment') === stored) return;
      sessionStorage.setItem('analytics_advisor_assignment', stored);
      sessionStorage.setItem('analytics_advisor_assignment_pending', stored);
    } catch (e) {}
    // Seçiniz stores the advisor and then opens the advisor page. Push on the
    // next page so the event is still in the dataLayer after that navigation.
    // If the page stays, push here once the cart update has had time to settle.
    window.setTimeout(flushPendingAdvisorAssignment, 4000);
  });

  flushPendingAdvisorAssignment();

  document.addEventListener('advisor:cleared', function () {
    try { sessionStorage.removeItem('analytics_advisor_assignment'); } catch (e) {}
  });

  function pushExceptionDebounced(config, description, errorMessage, errorFields) {
    if (!config) return;
    if (pushedForms[config.form_name] === 'success') return;
    var now = Date.now();
    if (exceptionAt[config.form_name] && now - exceptionAt[config.form_name] < 800) return;
    exceptionAt[config.form_name] = now;
    pushException(config, description, errorMessage, errorFields);
  }

  window.addEventListener('message', function (event) {
    if (event.origin !== 'https://formbuilder.hulkapps.com') return;
    var data = event.data;
    if (typeof data === 'string') {
      try { data = JSON.parse(data); } catch (e) { return; }
    }
    if (!data || typeof data !== 'object') return;

    var type = String(data.type || '');
    var formId = data.formId || data.form_id || (data.payload && (data.payload.form_id || data.payload.formId));

    if (type === 'vw:hulk-device-owner' && data.device_owner) {
      deviceOwnerByForm[formId || ''] = data.device_owner;
      return;
    }

    var config = hulkFormConfig(data);
    if (!config) return;

    if (type === 'vw:hulk-form-error') {
      pushExceptionDebounced(config, 'Form Error', data.error_message, data.error_fields);
      return;
    }

    var failed = data.success === false || (data.payload && data.payload.success === false) || /error|fail/i.test(type);

    if (type === 'form_submitted' && !failed) {
      pushFormSuccess(config, data.payload || data, formId);
      return;
    }

    if (!failed) return;
    var payload = data.payload || data;
    var fields = payload.error_fields || payload.fields;
    pushExceptionDebounced(
      config,
      fields ? 'Form Error' : 'Service Error',
      payload.error_message || payload.message,
      Array.isArray(fields) ? fields.join(', ') : fields
    );
  });

  document.addEventListener('cf:form_submitted', function (event) {
    var form = event.target;
    if (!form || !form.getAttribute) return;
    var config = formConfigFromElement(form);
    if (!config) return;
    pushFormSuccess(config, event.detail || {});
  }, true);

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || !form.getAttribute) return;
    var config = formConfigFromElement(form);
    if (!config) return;

    window.setTimeout(function () {
      if (pushedForms[config.form_name] === 'success') return;
      var invalid = form.querySelectorAll('[aria-invalid="true"], .cf-error, .cf-field-error, .cf-error-message');
      if (!invalid.length) return;

      var labels = [];
      var message;
      invalid.forEach(function (field) {
        var text = (field.textContent || '').replace(/\s+/g, ' ').trim();
        if (!message && text) message = text;
        var label = field.closest('label, .cf-field');
        var labelText = label ? (label.innerText || '').replace(/\s+/g, ' ').trim() : '';
        if (labelText && labels.indexOf(labelText) === -1) labels.push(labelText);
      });

      pushException(config, 'Form Error', message, labels.length ? labels.join(', ') : undefined);
    }, 60);
  }, true);

  function emptyValue(value) {
    return value === undefined || value === null || value === '' ? undefined : value;
  }

  function filterEntries(params) {
    var entries = [];
    params.forEach(function (value, key) {
      if (key.indexOf('filter.') === 0) entries.push(key + '\n' + value);
    });
    entries.sort();
    return entries;
  }

  function filterSearchTerm(params) {
    if (!document.body.classList.contains('template-search')) return undefined;
    var node = document.querySelector('[data-analytics-search-term]');
    var term = node ? String(node.getAttribute('data-analytics-search-term') || '').trim() : '';
    if (!term && params) term = String(params.get('q') || '').trim();
    if (term.indexOf('title:"') === 0 && term.indexOf('" OR product_type:"') !== -1) {
      term = term.slice(7).split('" OR product_type:"')[0].replace(/\\"/g, '"').trim();
    }
    if (!term) return undefined;
    if (term.indexOf('@') !== -1) return '[redacted]';
    if (term.replace(/\D/g, '').length >= 8) return '[redacted]';
    return term;
  }

  function filterResultsCount() {
    var el = document.querySelector('[data-results-count]');
    var count = el ? parseInt(el.getAttribute('data-results-count'), 10) : 0;
    return isFinite(count) ? count : 0;
  }

  function filterShownLabel(param, value) {
    var inputs = document.querySelectorAll('input[name="' + String(param).replace(/"/g, '\\"') + '"]');
    for (var i = 0; i < inputs.length; i++) {
      if (inputs[i].value !== value) continue;
      var label = inputs[i].closest('label');
      var textEl = label && label.querySelector('.tag__text');
      var text = textEl ? textEl.textContent.replace(/\s+/g, ' ').trim() : '';
      if (text) return text;
    }
    return value;
  }

  function filterPriceLabel(params) {
    var min;
    var max;
    params.forEach(function (value, key) {
      if (key.indexOf('price.gte') !== -1) min = Number(value) / 100;
      if (key.indexOf('price.lte') !== -1) max = Number(value) / 100;
    });
    if (min === undefined && max === undefined) return undefined;
    var shown = function (amount) {
      return amount === undefined || isNaN(amount) ? '' : String(amount);
    };
    return (shown(min) + ' - ' + shown(max)).trim();
  }

  function pushApplyFilter(payload) {
    dataLayer().push({
      event: 'apply_filter',
      search_term: emptyValue(payload.search_term),
      filter_type: emptyValue(payload.filter_type),
      filter_value: emptyValue(payload.filter_value),
      interaction_type: payload.interaction_type,
      results_count: payload.results_count
    });
  }

  function pushRemovedFilters(previousParams, removedEntries, searchTerm, results) {
    var priceRemoved = removedEntries.filter(function (entry) { return entry.indexOf('price') !== -1; });
    var otherRemoved = removedEntries.filter(function (entry) { return entry.indexOf('price') === -1; });

    if (priceRemoved.length) {
      var priceEntry = priceRemoved[0].split('\n');
      pushApplyFilter({
        search_term: searchTerm,
        filter_type: priceEntry[0] || undefined,
        filter_value: filterPriceLabel(previousParams),
        interaction_type: 'remove',
        results_count: results
      });
    }

    otherRemoved.forEach(function (entry) {
      var parts = entry.split('\n');
      var param = parts[0];
      var value = parts.slice(1).join('\n');
      pushApplyFilter({
        search_term: searchTerm,
        filter_type: param || undefined,
        filter_value: filterShownLabel(param, value),
        interaction_type: 'remove',
        results_count: results
      });
    });
  }

  function pushFilterDiff(previousSearch, nextParams) {
    var prev = new URLSearchParams(previousSearch || '');
    var next = nextParams instanceof URLSearchParams ? nextParams : new URLSearchParams(nextParams || '');
    var prevEntries = filterEntries(prev);
    var nextEntries = filterEntries(next);
    if (prevEntries.join('|') === nextEntries.join('|')) return;

    var searchTerm = filterSearchTerm(next);
    var results = filterResultsCount();
    if (!nextEntries.length) {
      pushRemovedFilters(prev, prevEntries, searchTerm, results);
      return;
    }

    var added = nextEntries.filter(function (entry) { return prevEntries.indexOf(entry) === -1; });
    var removed = prevEntries.filter(function (entry) { return nextEntries.indexOf(entry) === -1; });
    var priceChange = added.concat(removed).some(function (entry) { return entry.indexOf('price') !== -1; });

    if (priceChange) {
      var source = added.concat(removed).filter(function (entry) { return entry.indexOf('price') !== -1; })[0] || '';
      pushApplyFilter({
        search_term: searchTerm,
        filter_type: source.split('\n')[0] || undefined,
        filter_value: filterPriceLabel(next),
        interaction_type: nextEntries.some(function (entry) { return entry.indexOf('price') !== -1; }) ? 'add' : 'remove',
        results_count: results
      });
      return;
    }

    added.concat(removed).forEach(function (entry) {
      var parts = entry.split('\n');
      var param = parts[0];
      var value = parts.slice(1).join('\n');
      pushApplyFilter({
        search_term: searchTerm,
        filter_type: param || undefined,
        filter_value: filterShownLabel(param, value),
        interaction_type: added.indexOf(entry) !== -1 ? 'add' : 'remove',
        results_count: results
      });
    });
  }

  function consumeFilterNavigation() {
    if (window.vwAnalyticsFilterConsumed) return;
    window.vwAnalyticsFilterConsumed = true;
    if (!document.querySelector('item-grid, .collection-grid, .filter-form')) return;
    var reset = null;
    var before = null;
    try {
      reset = sessionStorage.getItem('analytics_apply_filter_reset');
      before = sessionStorage.getItem('analytics_filter_before');
      sessionStorage.removeItem('analytics_apply_filter_reset');
      sessionStorage.removeItem('analytics_filter_before');
    } catch (e) { return; }

    if (reset === '1') {
      pushApplyFilter({
        search_term: filterSearchTerm(new URLSearchParams(window.location.search)),
        interaction_type: 'reset',
        results_count: filterResultsCount()
      });
      return;
    }

    if (before !== null) pushFilterDiff(before, new URLSearchParams(window.location.search));
  }

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;
    if (target.closest('[data-filter-submit]')) {
      try { sessionStorage.setItem('analytics_filter_before', window.location.search); } catch (e) {}
    }
    var resetLink = target.closest('.js-reset-filters');
    if (resetLink && window.location.search.indexOf('filter.') !== -1) {
      try { sessionStorage.setItem('analytics_apply_filter_reset', '1'); } catch (e) {}
    }
  }, true);

  consumeFilterNavigation();
})();
